import '../../style.scss';
import { useHistory } from 'react-router-dom';
import { IProjectDocInfoMenu } from '../../../../model/api-modules/document';
import menuDown from '../../../../assets/images/menu-down.png';
import { AppEnvType } from '../../../../model';

interface IProps {
  readonly itemData: IProjectDocInfoMenu;
  readonly selectActive: ReadonlyArray<number>;
  readonly isExpand: Array<number>;
  readonly setIsExpand: any;
  readonly itemKey: string;
  readonly isDocPublicRoute: boolean;
}

interface IDocURLParams {
  readonly projectId: string;
  readonly docId: string;
}

export const LeftMenuItem = (props: IProps) => {
  const history = useHistory();

  const formatDocParamsByLocationPathname = (
    pathname: string
  ): IDocURLParams => {
    const names = pathname.split('/').slice(3);
    return {
      projectId: names[0] || '',
      docId: names[1] || '',
    };
  };
  const docParams = formatDocParamsByLocationPathname(location.pathname);

  const joinPath = (
    projectId: string | number | undefined,
    docId?: string | number
  ) => {
    if (!projectId) return;
    const url = props.isDocPublicRoute ? '/doc-public' : '/doc';
    if (docId) {
      history.push(`${url}/detail/${projectId}/${docId}`);
      return;
    }
    history.push(`${url}/detail/${projectId}`);
  };

  const joinDocumentPath = (docInfo: IProjectDocInfoMenu) => {
    let linkInfo: IProjectDocInfoMenu;
    // const isServices = docInfo.name === '服务使用手册' || docInfo.name === 'Services Manual';
    const isProd = process.env.REACT_APP_ENV === AppEnvType.Production;
    const testShow =
      !isProd &&
      ((docInfo.project_id === 38 && docInfo.id === 1055) ||
        (docInfo.project_id === 39 && docInfo.id === 1012));
    const prodShow =
      isProd &&
      ((docInfo.project_id === 35 && docInfo.id === 1103) ||
        (docInfo.project_id === 36 && docInfo.id === 1006));
    const isShowServices = testShow || prodShow;
    if (docInfo.content) {
      linkInfo = docInfo;
    } else {
      // 没内容的话，如果有子类，并且不是服务页，跳到子类的第一条数据
      if (
        Array.isArray(docInfo.nodes) &&
        docInfo.nodes.length > 0 &&
        !isShowServices
      ) {
        // eslint-disable-next-line prefer-destructuring
        linkInfo = docInfo.nodes[0];
      } else {
        linkInfo = docInfo;
      }
    }
    joinPath(linkInfo.project_id, linkInfo.id);
  };

  const setExpand = (
    e: React.MouseEvent<HTMLDivElement>,
    item: IProjectDocInfoMenu
  ) => {
    e.stopPropagation();
    if (item.nodes && item.nodes.length !== 0) {
      const expand = props.isExpand;
      if (props.isExpand.indexOf(item.id) !== -1) {
        expand.splice(props.isExpand.indexOf(item.id), 1);
        props.setIsExpand(expand);
      } else {
        expand.push(item.id);
        props.setIsExpand(expand);
      }
    }
    joinPath(docParams.projectId, docParams.docId);
  };

  return (
    <li key={props.itemKey}>
      <p
        onClick={() => {
          joinDocumentPath(props.itemData);
        }}
        className={
          props.selectActive.indexOf(props.itemData.id) !== -1
            ? 'list-item router-link-exact-active router-link-active active'
            : 'list-item router-link-active'
        }
      >
        <span className="item-inner">{props.itemData?.name}</span>
        {props.itemData.nodes && props.itemData.nodes.length !== 0 && (
          <img
            src={menuDown}
            onClick={(e) => setExpand(e, props.itemData)}
            className={
              props.isExpand.indexOf(props.itemData.id) === -1
                ? 'expand-img expand-img-hidden'
                : 'expand-img'
            }
          />
        )}
      </p>
      {props.itemData.nodes && props.itemData.nodes.length !== 0 && (
        <div
          className="expand-box"
          style={{
            display:
              props.isExpand.indexOf(props.itemData.id) === -1
                ? 'none'
                : 'block',
          }}
        >
          <ul>
            {props.itemData.nodes.map((it, idx) => {
              return (
                <LeftMenuItem
                  itemData={it}
                  selectActive={props.selectActive}
                  isExpand={props.isExpand}
                  setIsExpand={props.setIsExpand}
                  itemKey={`${props.itemKey}${idx}`}
                  isDocPublicRoute={props.isDocPublicRoute}
                />
              );
            })}
          </ul>
        </div>
      )}
    </li>
  );
};
